import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./theme";
import "./styles/analyzer.css";
import { BrowserRouter } from "react-router-dom";

const el = document.getElementById("root");
if (!el) throw new Error("Missing <div id='root'>");

ReactDOM.createRoot(el).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
